











import { Component, Vue, Prop, Emit, Model } from 'vue-property-decorator';

interface IColor {
    color: string;
    fontColor: string;
}

@Component({})
export default class ColorPicker extends Vue {
    public colors: IColor[] = [
        {color: 'Black', fontColor: 'White'},
        {color: 'Gray', fontColor: 'Black'},
        {color: 'DarkGray', fontColor: 'Black'},
        {color: 'LightGrey', fontColor: 'Black'},
        {color: 'White', fontColor: 'Black'},
        {color: 'Aquamarine', fontColor: 'Black'},
        {color: 'Blue', fontColor: 'Black'},
        {color: 'Navy', fontColor: 'White'},
        {color: 'Purple', fontColor: 'White'},
        {color: 'DeepPink', fontColor: 'Black'},
        {color: 'Violet', fontColor: 'Black'},
        {color: 'Pink', fontColor: 'Black'},
        {color: 'DarkGreen', fontColor: 'White'},
        {color: 'Green', fontColor: 'White'},
        {color: 'YellowGreen', fontColor: 'Black'},
        {color: 'Yellow', fontColor: 'Black'},
        {color: 'Orange', fontColor: 'Black'},
        {color: 'Red', fontColor: 'Black'},
        {color: 'Brown', fontColor: 'Black'},
        {color: 'BurlyWood', fontColor: 'Black'},
        {color: 'Beige', fontColor: 'Black'},
    ];


     @Model('change', { type: String })
    public value: string;

    public setValue(value: string) {
        this.$emit('change', value);
    }
}
